import type { IconNode } from '../types';

/**
 * @name pillow
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEuMyA3LjVhMiAyIDAgMSAwLTIuOS0yLjdDMTcgNC4zIDE0LjYgNCAxMiA0cy00LjkuMy02LjQuOGEyIDIgMCAxIDAtMi45IDIuNyAxNCAxNCAwIDAgMCAwIDkgMiAyIDAgMSAwIDIuOSAyLjdjMS41LjUgMy44LjggNi40LjhzNS0uMyA2LjQtLjhhMiAyIDAgMSAwIDIuOS0yLjcgMTQgMTQgMCAwIDAgMC05IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/pillow
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pillow: IconNode = [
  [
    'path',
    {
      d: 'M21.3 7.5a2 2 0 1 0-2.9-2.7C17 4.3 14.6 4 12 4s-4.9.3-6.4.8a2 2 0 1 0-2.9 2.7 14 14 0 0 0 0 9 2 2 0 1 0 2.9 2.7c1.5.5 3.8.8 6.4.8s5-.3 6.4-.8a2 2 0 1 0 2.9-2.7 14 14 0 0 0 0-9',
      key: '1je8x0',
    },
  ],
];

export default pillow;
